import { useCallback, useContext, useSyncExternalStore } from 'react';

import { FormTemplateRequestsContext } from '../FormChangeHistory.context';
import { getTemplateChangesStatus, hasTemplateOnEitherSide } from '../FormChangeHistory.utils';

import useTemplateRequest from './useTemplateRequest';

/**
 * A summarised template change's `template-changes` read. Nothing is read, and the status is empty,
 * when the summary says neither side holds a template (a Create writes every template field). With a
 * `kind`, an answer about another kind of template is not loaded data. A retry reaches every reader
 * of the change, so the panel's count reloads with the changeset.
 */
const useTemplateChanges = ({ change, detail, kind = null }) => {
  const requests = useContext(FormTemplateRequestsContext);

  const { changesRetries } = requests;
  const { auditId } = detail.summary;
  const hasTemplate = hasTemplateOnEitherSide(change.summary);

  const retryCount = useSyncExternalStore(changesRetries.subscribe, () =>
    changesRetries.getCount(auditId),
  );

  const loadChanges = useCallback(() => requests.getChanges(auditId), [requests, auditId]);
  const retry = useCallback(() => changesRetries.retry(auditId), [changesRetries, auditId]);

  const { status, data } = useTemplateRequest(hasTemplate ? loadChanges : null, retryCount);

  return {
    auditId,
    status: getTemplateChangesStatus({ hasTemplate, status, data, kind }),
    data,
    retry,
  };
};

export default useTemplateChanges;
